import React, { memo } from 'react';
import { Table, TableHead, TableBody, TableRow, TableCell, Typography, TableContainer, Stack, Tooltip, IconButton, Icon } from 'investira.react.components';
import { validators, formats } from 'investira.sdk';
import { Link } from 'react-router-dom';
import { ATIVO_TIPO } from '@investirapri/financa.js/lib/enums';
import { useConsultaContext } from '../../../../../contexts/ConsultaContext';
import { PessoaImage } from '../../../../../components/molecules';
import { displays } from 'investira.react.lib';
import { PATHS } from '../../../../../enums';
const OutrosDetalheTable = memo(props => {
  const {
    detalhe
  } = props;
  const {
    state
  } = useConsultaContext();
  function agruparPorAtivoTipoId(pDetalhe) {
    // Verifica se o input é um array
    if (!Array.isArray(pDetalhe)) {
      console.error('O parâmetro deve ser um array.');
      return {};
    }
    const agrupado = {};
    pDetalhe.forEach(item => {
      const tipoId = item.ativo_tipo_id;

      // Se o tipo não existir no objeto, cria um array vazio para ele
      if (!agrupado[tipoId]) {
        agrupado[tipoId] = [];
      }

      // Adiciona o item ao grupo correspondente
      agrupado[tipoId].push(item);
    });
    return agrupado;
  }
  function calcAlvoRange(pAlvo = null, pAlvoLimites = {}, pDesenquadradoAlvo = null, pDesenquadrado = null) {
    let targetColors = 'white';
    if (!validators.isNull(pDesenquadrado)) {
      targetColors = 'error.light';
    }
    if (!validators.isNull(pDesenquadradoAlvo)) {
      targetColors = 'warning.light';
    }
    return {
      alvo: pAlvo,
      alvoLimites: pAlvoLimites,
      alvoWidth: pAlvoLimites?.maximo - pAlvoLimites.minimo,
      desenquadradoAlvo: !validators.isNull(pDesenquadradoAlvo),
      pDesenquadrado: !validators.isNull(pDesenquadrado),
      noAlvo: !validators.isNull(pDesenquadradoAlvo),
      targetColor: targetColors
    };
  }
  function getDetalheFiltrado(detalhe, state) {
    return state.exibir_desenquadrado ? detalhe.filter(x => x.desenquadrado) : detalhe;
  }
  return <TableContainer id="table-container" sx={{
    overflow: 'auto'
  }}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Descrição</TableCell>
            <TableCell></TableCell>
            <TableCell></TableCell>
            <TableCell align="right">Observado</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {detalhe.map(xItem => {
          return <React.Fragment key={crypto.randomUUID()}>
                <TableRow sx={{
              backgroundColor: theme => theme.palette.secondary.dark
            }}>
                  <TableCell colSpan="3">
                    <b>{xItem?.descricao}</b>
                  </TableCell>

                  <TableCell align="right">
                    {xItem.financeiro && formats.formatNumber(xItem.financeiro, 2, true)}
                  </TableCell>
                  <TableCell sx={{
                width: '24px'
              }}></TableCell>
                </TableRow>

                {!validators.isEmpty(xItem.criterio) && <TableRow>
                    <TableCell colSpan="5">
                      <Typography variant="caption" color={'textSecondary'}>
                        {xItem.criterio.join(', ')}
                      </Typography>
                    </TableCell>
                  </TableRow>}

                {Object.entries(agruparPorAtivoTipoId(getDetalheFiltrado(xItem.detalhe, state))).map(([xAtivoTipoId, xDetalhes]) => {
              const xTotalPorAtivoTipo = xDetalhes.reduce((acc, item) => {
                if (item.financeiro) {
                  return acc + item.financeiro;
                }
                return 0;
              }, 0);
              return <React.Fragment key={crypto.randomUUID()}>
                      {!validators.isNull(xAtivoTipoId) && <TableRow>
                          <TableCell colSpan="3" sx={{
                    pl: 4
                  }}>
                            <b>{ATIVO_TIPO[xAtivoTipoId]?.descricao}</b>
                          </TableCell>
                          <TableCell sx={{
                    pl: 4
                  }} align="right">
                            {formats.formatNumber(xTotalPorAtivoTipo, 2, true)}
                          </TableCell>
                          <TableCell></TableCell>
                        </TableRow>}

                      {xDetalhes.map(xAtivo => {
                  const xAlvo = calcAlvoRange(xAtivo.alvo, xAtivo.alvo_limites, xAtivo.desenquadrado_alvo, xAtivo.desenquadrado);
                  const xMercado = ATIVO_TIPO[xAtivoTipoId]?.mercado;
                  const xPath = xMercado ? `/ativos${PATHS[xMercado.toLowerCase()].path}/${xAtivo.ifeed_ativo_id}` : null;
                  return <TableRow>
                            <TableCell sx={{
                      pl: 6,
                      width: '24px'
                    }}>
                              {Boolean(xAtivo?.logo_pessoa_id) && !Boolean(xAtivo?.emissor) && <Link to={`/empresas/${xAtivo.logo_pessoa_id}`} target="_blank" rel="noopener noreferrer">
                                  <PessoaImage logoPessoaId={xAtivo.logo_pessoa_id} alt={xAtivo.pessoa_fantasia} hasLogo={Boolean(xAtivo?.logo_pessoa_id)} size={24} />
                                </Link>}

                              {Boolean(xAtivo?.logo_pessoa_id) && Boolean(xAtivo?.emissor) && <Tooltip title={xAtivo.emissor.pessoa_fantasia} arrow={true}>
                                  <span>
                                    <Link to={`/empresas/${xAtivo.logo_pessoa_id}`} target="_blank" rel="noopener noreferrer">
                                      <PessoaImage logoPessoaId={xAtivo.logo_pessoa_id} alt={xAtivo.pessoa_fantasia} hasLogo={Boolean(xAtivo?.logo_pessoa_id)} size={24} />
                                    </Link>
                                  </span>
                                </Tooltip>}
                            </TableCell>
                            <TableCell sx={{
                      color: xAlvo.targetColor
                    }}>
                              {xAtivo?.pessoa_fantasia ? <Typography component={Link} to={`/empresas/${xAtivo.pessoa_id}`} color="primary" target="_blank" rel="noopener noreferrer" variant="body2" aria-label={`Abrir ${xAtivo?.ativo} em uma nova aba`}>
                                  {xAtivo.pessoa_fantasia}
                                </Typography> : xAtivo?.pessoa_fantasia}

                              {xPath ? <Typography component={Link} to={xPath} color="primary" target="_blank" rel="noopener noreferrer" variant="body2" aria-label={`Abrir ${xAtivo?.ativo} em uma nova aba`}>
                                  {xAtivo?.ativo}
                                </Typography> : xAtivo.descricao || xAtivo?.ativo}
                            </TableCell>
                            <TableCell sx={{
                      whiteSpace: 'nowrap',
                      textAlign: xAtivo?.cnpj ? 'right' : 'left'
                    }}>
                              {xAtivo?.isin || displays.cnpj(xAtivo?.cnpj)}
                            </TableCell>

                            <TableCell align="right" sx={{
                      color: xAlvo.targetColor
                    }}>
                              <Stack direction="row" alignItems="center" justifyContent="right" gap={1}>
                                {(xAtivo.financeiro || xAtivo.quantidade) && formats.formatNumber(xAtivo.financeiro || xAtivo.quantidade, xAtivo.decimais || 0, true)}
                              </Stack>
                            </TableCell>
                            <TableCell align="center">
                              <Stack direction="row" alignItems="center" justifyContent="right" gap={1}>
                                {xAtivo.base && <Tooltip title={<Stack px={1} py={1}>
                                        {Object.entries(xAtivo.base).map(([key, value]) => <Typography variant="caption" key={key}>
                                            <strong>{key}:</strong>{' '}
                                            {key === 'Data' ? formats.formatDate(value) : typeof value === 'object' ? Object.entries(value).map(([k, v]) => {
                              if (k === 'ON' || k === 'PN') {
                                return `${k}: ${formats.formatNumber(v, 0, true)}`;
                              } else {
                                return `${k}: ${v}`;
                              }
                            }).join(', ') : typeof value === 'number' ? formats.formatNumber(value, xAtivo.decimais || 0, true) : value}
                                          </Typography>)}
                                      </Stack>} arrow={true}>
                                    <IconButton color="primary" size="small">
                                      <Icon iconName="information" size={16} />
                                    </IconButton>
                                  </Tooltip>}
                              </Stack>
                            </TableCell>
                          </TableRow>;
                })}
                    </React.Fragment>;
            })}
              </React.Fragment>;
        })}
        </TableBody>
      </Table>
    </TableContainer>;
});
export default OutrosDetalheTable;
